module.exports = __webpack_public_path__ + "static/img/cooperation_icon.e402f9d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images2/cooperation_icon.png
// module id = FDX5
// module chunks = 2